module.exports = {
        srcSet: __webpack_public_path__ + "8e28a6c5a0400194-600.webp"+" 600w"+","+__webpack_public_path__ + "d237857fd045d7c3-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "8e28a6c5a0400194-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "d237857fd045d7c3-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "d237857fd045d7c3-1000.webp",
        toString: function(){return __webpack_public_path__ + "d237857fd045d7c3-1000.webp"},
        
        width: 1000,
        height: 667
      }